import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { customStyles } from "../../../../../../../pages/customStyles";
import createInfo from "./IndividualBookInfoCreate.module.css";
import { ImageUrlPrefix } from "../../../../../../../labels";
import { Link, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import Creatable from "react-select/creatable";
import { AxiosInstance } from "../../../../../../../axios";
import toast from "react-hot-toast";
import axios from "axios";
import fileDownload from "js-file-download";
import DropdownHeader from "../../../../CourseBatch/DropdownHeader";
export default function IndividualBookInfoCreate() {
  const { id } = useParams();
  const navigate = useNavigate();
  const baseURL = AxiosInstance.defaults.baseURL;
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }
  const [error, setError] = useState({});

  const [images, setImages] = useState([]);
  const [imageURLS, setImageURLs] = useState([]);
  const [authorList, setAuthorList] = useState([]);
  const [publisherList, setPublisherList] = useState([]);
  const [tagsList, setTagsList] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [removedValues, setRemovedValues] = useState([]);
  const ebook_ref = useRef(null);
  const visible_ref = useRef();
  const book_name_ref = useRef(null);
  const author_ref = useRef(null);
  const pulisher_ref = useRef(null);
  const isbn_ref = useRef(null);
  const tnopage_ref = useRef(null);
  const answer_sheet_ref = useRef(null);
  const book_path_url_ref = useRef(null);
  const description_ref = useRef(null);
  const tagLine_ref = useRef(null);
  const stock_count_ref = useRef(null);
  const price_ref = useRef(null);
  const offerPer_ref = useRef(null);
  const category_ref = useRef(null);
  const course_ref = useRef(null);
  const subject_ref = useRef(null);
  const medium_ref = useRef(null);
  const youtube_ref = useRef(null);
  const length_ref = useRef(null);
  const width_ref = useRef(null);
  const thickness_ref = useRef(null);
  const weight_ref = useRef(null);
  const tagsGrouping_ref = useRef(null);
  const seriesTag_ref = useRef(null);
  const upload_image_ref = useRef(null);

  const [prevFiles, setPrevFiles] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [isStockChanged, setIsStockChanged] = useState(false);
  const [optionsValue, setOptionsValue] = useState();

  const [initialfields, setInitialfields] = useState({
    ebook: 0,
    visibleUser: 0,
    bookName: "",
    filePdfName: true,
    // author: [],
    dimension: "",
    authorGrouping: "",
    authorLabel: "",
    publisherLabel: "",
    publisheGrouping: "",
    tagsGrouping: "",
    tagsLabel: "",
    isbnNumber: "",
    tnoPage: "",
    preview_path: "",
    original_preview_path: "",
    iframe: "",
    bookPathUrl: "",
    description: "",
    stockCount: "",
    addCount: "",
    price: "",
    offerPer: "",
    categoryGrouping: "",
    CategoryTypeLabel: "",
    courseGrouping: "",
    CourseTypeLabel: "",
    type: "",
    subjectGrouping: "",
    subjectTypeLabel: "",
    seriesGrouping: "",
    seriesTypeLabel: "",
    course: "",
    subject: "",
    mediumGrouping: "",
    mediumTypeLabel: "",
    length: "",
    width: "",
    thickness: "",
    weight: "",
    tagLine: "",
    // tags: "",
    upload_image_path: [],
    upload_image_original_path: "",
    upload_image_id: "",
  });

  const [isFreeBook, setIsFreeBook] = useState(0);

  const [category, setCategory] = useState();

  const [groupName, setGroupName] = useState([]);

  const [subjectGroupName, setSubjectGroupName] = useState();

  const handleChange = (event) => {
    let { name, files, value } = event.target;

    if (files > 2 * 1024 * 1024) {
      setError((prevState) => ({
        ...prevState,
        upload_image_path: "Please upload a valid PDF under 10 MB",
      }));
    }
    // if (name === "description") {
    //   value = value.replace(/^['"]+|['"]+$/g, "");
    // }
    if (name === "preview_path") {
      if (files && files.length > 0) {
        const course_content_path = files[0];
        setPrevFiles(files[0].type);

        if (course_content_path.size > 10 * 1024 * 1024) {
          setError((prevState) => ({
            ...prevState,
            preview_path: "Please upload a valid PDF under 10 MB",
          }));
          return;
        }
        setInitialfields({
          ...initialfields,
          preview_path: null,
          original_preview_path: null,
        });

        if (files[0].type === "application/pdf") {
          const formData = new FormData();
          formData.append("book_pdf", course_content_path);
          AxiosInstance.post("api/upload", formData)
            .then((res) => {
              setInitialfields({
                ...initialfields,
                original_preview_path: res.data.originalname,
                preview_path: res.data.path,
                filePdfName: true,
              });
            })
            .catch((error) => {
              return error;
            });
          setError({
            ...error,
            [name]: "",
          });
        } else {
          setError({
            ...error,
            [name]:
              "Only PDF files are allowed. Please upload a valid PDF under 10 MB ",
          });
          setInitialfields({
            ...initialfields,
            preview_path: null,
            original_preview_path: null,
            filePdfName: false,
          });
        }
      } else {
        setInitialfields({
          ...initialfields,
          preview_path: null,
          original_preview_path: null,
        });
        setError({
          ...error,
          [name]: "",
        });
      }
    } else if (name === "uploadPrevImage") {
      if (files && files.length > 0) {
        const selectedFiles = Array.from(files);
        const oversizedFiles = selectedFiles.filter(
          (file) => file.size > 2 * 1024 * 1024
        );

        if (oversizedFiles.length > 0) {
          const fileNames = oversizedFiles.map((file) => file.name).join(", ");
          setError((prevState) => ({
            ...prevState,
            upload_image_path: `The following image(s) exceed 2MB: ${fileNames}. Please ensure each image is less than 2MB.`,
          }));
          return;
        }

        const existingValidImages =
          initialfields.upload_image_path?.filter(
            (image) => image.is_valid !== 0
          ) || [];
        const totalFiles = existingValidImages.length + selectedFiles.length;

        if (totalFiles > 4) {
          setError((prevError) => ({
            ...prevError,
            upload_image_path: "Please upload up to 4 images",
          }));
          return;
        }

        const formData = new FormData();
        selectedFiles.forEach((file) => {
          formData.append("book_image", file);
        });

        AxiosInstance.post("api/upload/", formData)
          .then((res) => {
            const newImages = res.data.path.map((item) => ({
              path: item.path,
              originalname: item.originalname,
              is_valid: 1,
              isFromAPI: false, // ✅ Mark as new image
            }));

            setInitialfields((prevState) => ({
              ...prevState,
              upload_image_path: [
                ...(prevState.upload_image_path || []),
                ...newImages,
              ],
              upload_image_original_path: [
                ...(prevState.upload_image_original_path || []),
                ...res.data.path.map((item) => item.originalname),
              ],
            }));

            setError((prev) => ({
              ...prev,
              upload_image_path: "",
            }));
          })
          .catch(() => {
            setError((prev) => ({
              ...prev,
              upload_image_path: "Error uploading images",
            }));
          });

        // Reset file input so re-uploading same file triggers onChange
        event.target.value = null;
      }
    }
    //  else if (name === "isbnNumber") {
    //   const regex = /^(?:\d{10}|\d{13})$/; // Match exactly 10 or 13 digits
    //   if (regex.test(value)) {
    //     setInitialfields((prevFields) => ({
    //       ...prevFields,
    //       [name]: value,
    //     }));
    //     setError({
    //       ...error,
    //       [name]: "", // Clear error when valid
    //     });
    //   } else {
    //     setInitialfields((prevFields) => ({
    //       ...prevFields,
    //       [name]: value,
    //     }));
    //     setError({
    //       ...error,
    //       [name]: "ISBN number must be either 10 or 13 digits",
    //     });
    //   }
    // }
    else if (
      name === "tnoPage" ||
      name === "stockCount" ||
      name === "addCount" ||
      name === "price" ||
      name === "length" ||
      name === "width" ||
      name === "thickness"
    ) {
      const regex = /^[0-9]{1,5}$/;
      if (regex.test(value)) {
        setInitialfields((prevFields) => {
          // If stockCount changes, set isStockChanged
          if (
            name === "stockCount" ||
            (name === "addCount" &&
              parseInt(value) !== parseInt(prevFields.stockCount))
          ) {
            setIsStockChanged(true);
          }

          return {
            ...prevFields,
            [name]: value,
          };
        });

        setError({
          ...error,
          [name]: "",
        });
      } else {
        setInitialfields((prevFields) => ({
          ...prevFields,
          [name]: value,
        }));

        if (value < 0) {
          setError({
            ...error,
            [name]: "Value cannot be negative",
          });
        } else if (value.length > 5) {
          setError({
            ...error,
            [name]: "Value cannot exceed 5 digits",
          });
        } else {
          setError({
            ...error,
            [name]: "Please enter a valid number between 0 and 100000",
          });
        }
      }
    } else if (name === "offerPer") {
      const regex = /^[0-9]{1,2}$/; // Match 1 to 5 digits only (no negative numbers)
      if (regex.test(value)) {
        setInitialfields((prevFields) => ({
          ...prevFields,
          [name]: value,
        }));
        setError({
          ...error,
          [name]: "", // Clear error when valid
        });
      } else {
        setInitialfields((prevFields) => ({
          ...prevFields,
          [name]: value, // Allow user to type while checking validity
        }));
        if (value < 0) {
          setError({
            ...error,
            [name]: "Value cannot be negative",
          });
        } else if (value.length > 1) {
          setError({
            ...error,
            [name]: "Value cannot exceed 2 digits",
          });
        } else {
          setError({
            ...error,
            [name]: "Please enter a valid number between 0 and 100",
          });
        }
      }
    } else if (name === "weight") {
      const regex = /^\d{0,5}(\.\d{1,3})?$/; // Match 1 to 5 digits with optional 1 to 3 decimals
      if (value.startsWith("-")) {
        setError({
          ...error,
          [name]: "Value cannot be negative",
        });
        setInitialfields((prevFields) => ({
          ...prevFields,
          [name]: "",
        }));
        return;
      }
      if (regex.test(value) && parseFloat(value) >= 0) {
        setInitialfields((prevFields) => ({
          ...prevFields,
          [name]: value,
        }));
        setError({
          ...error,
          [name]: "", // Clear error when valid
        });
      } else {
        setInitialfields((prevFields) => ({
          ...prevFields,
          [name]: value, // Allow user to type while checking validity
        }));
        if (parseFloat(value) < 0) {
          setError({
            ...error,
            [name]: "Value cannot be negative",
          });
        } else if (value.includes(".") && value.split(".")[0].length > 5) {
          setError({
            ...error,
            [name]: "Weight cannot exceed 5 digits before the decimal",
          });
        } else if (value.includes(".") && value.split(".")[1]?.length > 3) {
          setError({
            ...error,
            [name]: "Weight cannot have more than 3 decimal places",
          });
        } else if (!value.includes(".") && value.length > 5) {
          setError((prevError) => ({
            ...prevError,
            [name]: "Value cannot exceed 5 digits",
          }));
        } else {
          setError((prevError) => ({
            ...prevError,
            [name]: "",
          }));
        }
      }
    } else {
      setInitialfields((prevFields) => ({
        ...prevFields,
        [name]: value,
      }));
      setError({
        ...error,
        [name]: "",
      });
    }
  };

  const transformData = (data) => {
    const transformedData = [];

    data.forEach((item) => {
      const groupLabel = item.subcategory_code;
      const option = {
        value: item.id,
        label: item.course_name,
        category_code: item.category_code,
        name: item.name,
        subcategory_code: item.subcategory_code,
        type: item.type,
      };

      // Check if the group already exists in transformedData
      const groupIndex = transformedData.findIndex(
        (group) => group.label === groupLabel
      );

      if (groupIndex === -1) {
        // Group doesn't exist, create a new group
        transformedData.push({
          label: groupLabel,
          options: [option],
        });
      } else {
        // Group exists, add the option to the existing group
        transformedData[groupIndex].options.push(option);
      }
    });

    return transformedData;
  };

  const courseListSortData = subjects
    .filter((item) => item && item.label) // Filter out null and undefined elements
    .sort((a, b) => a.label.localeCompare(b.label));

  const handleChangeCheckbox = (e, label) => {
    if (e) {
      setInitialfields((prevState) => ({
        ...prevState,
        ["CourseTypeLabel"]: e.label,
        ["courseGrouping"]: e.value,
        ["courseNameCategory"]: e.label,
        ["courseSubCategory"]: e.subcategory_code,
        ["type"]: e.type,
        subjectTypeLabel: "",
        subjectGrouping: "",
      }));

      setError({
        ...error,
        ["class_name"]: "",
      });
    } else {
      setSubjectGroupName([]);
      setInitialfields((prevState) => ({
        ...prevState,
        ["CourseTypeLabel"]: "",
        ["courseGrouping"]: "",
        ["courseNameCategory"]: "",
        ["courseSubCategory"]: "",
        subjectTypeLabel: "",
        subjectGrouping: "",
      }));
      setError({
        ...error,
        ["courseGrouping"]: "Please select course for respective category",
      });
    }
  };

  const handlechangeSelectDropdown = (selectedOptions, dname) => {
    const isNew = "";
    if (dname === "authorGrouping") {
      if (selectedOptions) {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: selectedOptions.value,
          ["authorLabel"]: selectedOptions.label,
        }));
        setError({
          ...error,
          [dname]: "",
        });
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: "",
          ["authorLabel"]: "",
        }));
        setError({
          ...error,
          [dname]: "",
        });
      }
    } else if (dname === "publisheGrouping") {
      if (selectedOptions) {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: isNew ? "" : selectedOptions.value,
          ["publisherLabel"]: selectedOptions.label,
          // ...(isNew && { name: "", id: "" }),
        }));
        setError({
          ...error,
          [dname]: "",
        });
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: "",
          ["publisherLabel"]: "",
          // ...(isNew && { name: "", id: "" }),
        }));
        setError({
          ...error,
          [dname]: "",
        });
      }
    } else if (dname === "tagsGrouping") {
      if (selectedOptions) {
        // const selectedLabels = selectedOptions.map((option) => option.label);
        const selectedLabels = selectedOptions.map((option) => option.label);
        const selectedValues = selectedOptions.map((option) =>
          option.__isNew__ ? "" : option.value
        );
        if (selectedLabels.length > 8) {
          setError({
            ...error,
            [dname]: "You can only select a maximum of 8 tags",
          });
        } else {
          setInitialfields((prevState) => ({
            ...prevState,
            [dname]: selectedValues,
            ["tagsLabel"]: selectedLabels,
            // ...(isNew && { name: "", id: "" }),
          }));
          setError({
            ...error,
            [dname]: "",
          });
        }
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: "",
          ["tagsLabel"]: "",
        }));
        setError({
          ...error,
          [dname]: "",
        });
      }
    } else if (dname === "categoryGrouping") {
      if (selectedOptions) {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: selectedOptions.value,
          ["CategoryTypeLabel"]: selectedOptions.label,
        }));
        setInitialfields((prevFields) => ({
          ...prevFields,
          courseGrouping: "",
          CourseTypeLabel: "",
          subjectGrouping: "",
          subjectTypeLabel: "",
        }));
        setError({
          ...error,
          [dname]: "",
        });
      } else {
        setSubjects([]);
        setSubjectGroupName([]);
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: "",
          ["CategoryTypeLabel"]: "",
          courseGrouping: "",
          CourseTypeLabel: "",
          subjectGrouping: "",
          subjectTypeLabel: "",
        }));
        setError({
          ...error,
          [dname]: "",
        });
      }
    } else if (dname === "courseGrouping") {
      if (selectedOptions) {
        setOptionsValue(selectedOptions);
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: selectedOptions.value,
          ["CourseTypeLabel"]: selectedOptions.label,
          ["subjectGrouping"]: "",
          ["subjectTypeLabel"]: "",
        }));
        setError({
          ...error,
          [dname]: "",
        });
      } else {
        setOptionsValue([]);
        setSubjectGroupName([]);
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: "",
          ["CourseTypeLabel"]: "",
          ["subjectGrouping"]: "",
          ["subjectTypeLabel"]: "",
        }));
        setError({
          ...error,
          [dname]: "",
        });
      }
    } else if (dname === "subjectGrouping") {
      if (selectedOptions) {
        console.log(selectedOptions, "optionsValue");
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: selectedOptions.pk,
          ["subjectTypeLabel"]: selectedOptions.label,
        }));
        setError({
          ...error,
          [dname]: "",
        });
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: "",
          ["subjectTypeLabel"]: "",
        }));
        setError({
          ...error,
          [dname]: "",
        });
      }
    } else if (dname === "mediumGrouping") {
      if (selectedOptions) {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: selectedOptions.value,
          ["mediumTypeLabel"]: selectedOptions.label,
        }));
        setError({
          ...error,
          [dname]: "",
        });
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: "",
          ["mediumTypeLabel"]: "",
        }));
        setError({
          ...error,
          [dname]: "",
        });
      }
    } else if (dname === "seriesGrouping") {
      if (selectedOptions) {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: selectedOptions.value,
          ["seriesTypeLabel"]: selectedOptions.label,
        }));
        setError({
          ...error,
          [dname]: "",
        });
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: "",
          ["seriesTypeLabel"]: "",
        }));
        setError({
          ...error,
          [dname]: "",
        });
      }
    }
  };

  // const handleDelete = (indexToDelete) => {
  //   setInitialfields((prevState) => {
  //     const updatedImages = prevState.upload_image_path.map((imageObj, index) =>
  //       index === indexToDelete
  //         ? { ...imageObj, is_valid: 0 } // Mark `is_valid` as 0 for the deleted image
  //         : imageObj
  //     );
  //     return {
  //       ...prevState,
  //       upload_image_path: updatedImages,

  //     };
  //   });
  // };
  const handleDelete = (event, indexToDelete) => {
    event.preventDefault();
    setInitialfields((prevState) => {
      const updatedUploadPaths = [...prevState.upload_image_path];
      const updatedOriginalPaths = [
        ...(prevState.upload_image_original_path || []),
      ];

      const imageToDelete = updatedUploadPaths[indexToDelete];

      if (imageToDelete?.isFromAPI && imageToDelete.image_id) {
        // Mark API image as invalid
        updatedUploadPaths[indexToDelete] = {
          ...imageToDelete,
          is_valid: 0,
        };
      } else {
        // Remove newly uploaded image
        updatedUploadPaths.splice(indexToDelete, 1);
        updatedOriginalPaths.splice(indexToDelete, 1);
      }

      return {
        ...prevState,
        upload_image_path: updatedUploadPaths,
        upload_image_original_path: updatedOriginalPaths,
      };
    });
  };

  const handleWheel = (e) => {
    e.preventDefault();
  };
  useEffect(() => {
    AxiosInstance.get("api/course/category_list")
      .then((res) => {
        const ccategory = res.data?.data?.map((item, index) => ({
          value: item.id,
          label: item.name,
        }));
        setCategory(ccategory);
      })
      .catch((error) => {
        return error;
      });
  }, []);
  useEffect(() => {
    const inputElement = isbn_ref.current;
    const tnopages = tnopage_ref.current;

    if (inputElement) {
      inputElement.addEventListener("wheel", handleWheel);
    } else if (tnopages) {
      tnopages.addEventListener("wheel", handleWheel);
    }

    // Cleanup the event listener on component unmount
    return () => {
      if (inputElement) {
        inputElement.removeEventListener("wheel", handleWheel);
      } else if (tnopages) {
        tnopages.removeEventListener("wheel", handleWheel);
      }
    };
  }, []);
  useEffect(() => {
    const mrp = price_ref.current;
    if (mrp) {
      mrp.addEventListener("wheel", handleWheel);
    }
    return () => {
      if (mrp) {
        mrp.removeEventListener("wheel", handleWheel);
      }
    };
  }, []);
  useEffect(() => {
    const offerPer = offerPer_ref.current;

    if (offerPer) {
      offerPer.addEventListener("wheel", handleWheel);
    }
    return () => {
      if (offerPer) {
        offerPer.removeEventListener("wheel", handleWheel);
      }
    };
  }, []);
  useEffect(() => {
    const offerPer = offerPer_ref.current;

    if (offerPer) {
      offerPer.addEventListener("wheel", handleWheel);
    }
    return () => {
      if (offerPer) {
        offerPer.removeEventListener("wheel", handleWheel);
      }
    };
  }, []);
  useEffect(() => {
    const stock = stock_count_ref.current;

    if (stock) {
      stock.addEventListener("wheel", handleWheel);
    }
    return () => {
      if (stock) {
        stock.removeEventListener("wheel", handleWheel);
      }
    };
  }, []);
  useEffect(() => {
    const length = length_ref.current;
    if (length) {
      length.addEventListener("wheel", handleWheel);
    }
    return () => {
      if (length) {
        length.removeEventListener("wheel", handleWheel);
      }
    };
  }, []);
  useEffect(() => {
    const width = width_ref.current;

    if (width) {
      width.addEventListener("wheel", handleWheel);
    }
    return () => {
      if (width) {
        width.removeEventListener("wheel", handleWheel);
      }
    };
  }, []);
  useEffect(() => {
    const thickness = thickness_ref.current;

    if (thickness) {
      thickness.addEventListener("wheel", handleWheel);
    }
    return () => {
      if (thickness) {
        thickness.removeEventListener("wheel", handleWheel);
      }
    };
  }, []);
  useEffect(() => {
    const weight = weight_ref.current;

    if (weight) {
      weight.addEventListener("wheel", handleWheel);
    }
    return () => {
      if (weight) {
        weight.removeEventListener("wheel", handleWheel);
      }
    };
  }, []);

  useEffect(() => {
    if (
      initialfields.dimension &&
      typeof initialfields.dimension === "string"
    ) {
      // Ensure spaces are added around 'x' before splitting
      // const formattedDimension = initialfields.dimension.replace(/x/g, " x ");
      // const [length, width, thickness] = formattedDimension.split(" x ");
      const [length, width, thickness] = initialfields.dimension.split("x");
      setInitialfields((prevState) => ({
        ...prevState,
        length: length || "",
        width: width || "",
        thickness: thickness || "",
      }));
    }
  }, [initialfields.dimension]);
  const extractIframeSrc = (iframeString) => {
    if (!iframeString) return ""; // If empty, return empty string

    // Extract the src URL from the iframe tag if present
    const match = iframeString.match(/src="([^"]*)"/);
    return match ? match[1] : iframeString; // If match found, return src URL; otherwise, return as-is
  };
  useEffect(() => {
    setIsLoading(true);
    AxiosInstance.post("api/book/findById", { id: parseInt(id) })
      .then((res) => {
        if (res.data.status === true) {
          setIsFreeBook(res.data.data.is_free_book);
          setInitialfields({
            bookName: res.data.data.book_title,
            authorLabel: res.data.data.author,
            authorGrouping: res.data.data.author_id,
            publisherLabel: res.data.data.publisher,
            publisheGrouping: res.data.data.publisher_id,
            isbnNumber: res.data.data.isbn_no,
            price: res.data.data.price,
            offerPer: res.data.data.offer_percentage,
            finalPrice: res.data.data.finalPrice,
            description: res.data.data.description,
            stockCount: res.data.data.stock_count,
            CategoryTypeLabel: res.data.data.category_name,
            categoryGrouping: res.data.data.category_id,
            CourseTypeLabel: res.data.data.group_course_name,
            courseGrouping: res.data.data.group_course_id,
            subjectGrouping: res.data.data.subject_id,
            subjectTypeLabel: res.data.data.subject_name,
            // group_course_name: res.data.data.group_course_name,
            // subject_name: res.data.data.subject_name,
            tagLine: res.data.data.tag_line,
            mediumTypeLabel: res.data.data.medium,
            mediumGrouping: res.data.data.medium_id,
            seriesGrouping: res.data.data.series_id,
            seriesTypeLabel: res.data.data.series_name,
            is_visible: res.data.data.is_visible,
            tagsLabel: res.data.data.tags.map((item) => item.tag_name),
            tagsGrouping: res.data.data.tags.map((item) => item.tag_id),
            weight: res.data.data.weight,
            tnoPage: res.data.data.total_pages,
            iframe: extractIframeSrc(res.data.data.iframe),
            // iframe: res.data.data.iframe,
            // iframe: res.data.data.iframe
            //   ? res.data.data.iframe.match(/src="([^"]*)"/)?.[1] ||
            //     res.data.data.iframe // Extract src from iframe tag
            //   : "",
            dimension: res.data.data.dimension,
            bookPathUrl: res.data.data.ebook_url,
            preview_path: res.data.data.preview_path,
            original_preview_path: res.data.data.original_preview_path,
            ebook: res.data.data.is_ebook,
            visibleUser: res.data.data.is_visible,
            upload_image_original_path: res.data.data.images.map(
              (item) => item.original_book_image_path
            ),
            // upload_image_path: res.data.data.images.map(
            //   (item) => item.book_image_path
            // ),
            upload_image_path: res.data.data.images.map((item) => ({
              path: item.book_image_path,
              originalname: item.original_book_image_path,
              image_id: item.image_id,
              is_valid: 1,
              isFromAPI: true,
            })),
            upload_image_id: res.data.data.images.map((item) => item.image_id),
            book_in_set: res.data.data.book_in_set,
          });
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  }, [id]);

  useEffect(() => {
    if (initialfields.CategoryTypeLabel !== "") {
      AxiosInstance.get(
        `/api/all/getCourses/${initialfields.CategoryTypeLabel}/${0}`
      )
        .then((res) => {
          const subcategory = res.data.data.map((item, index) => ({
            value: item.id,
            label: item.name,
            subCategory: item.subcategory_code,
            course_name: item.course_name,
            type: item.type,
          }));
          const options_class_name = transformData(res.data.data);
          setSubjects(options_class_name);

          // const subcategorys = res.data.data;

          // const bb = res.data.data
          //   .filter((el) => el.subcategory_code)
          //   .map((el, index) => ({
          //     id: el.id,
          //     value: el.subcategory_code,
          //     label: el.subcategory_code,
          //     name: el.name,
          //     subCategory: el.subcategory_code,
          //     course_name: el.course_name,
          //     ind: index,
          //     isArr: true,
          //   }));
          // const uniqueValuesSet = new Set();
          // const uniqueData = bb.filter((item) => {
          //   if (!uniqueValuesSet.has(item.subCategory)) {
          //     uniqueValuesSet.add(item.subCategory);
          //     return true;
          //   }
          //   return false;
          // });

          // const Tempndex = uniqueData.map((el, index) => ({
          //   ...el,
          //   ind: index,
          //   isArr: true,
          // }));
          // setUniqueCoursedata(Tempndex);

          // const options_class_name = transformData(res.data.data);
          // setSubjects(options_class_name);

          // setSubcategory(subcategorys);
          setGroupName(subcategory);
          // setSubjectselect([]);
        })
        .catch((error) => {
          return error;
        });
    }
  }, [initialfields.CategoryTypeLabel]);

  useEffect(() => {
    if (
      initialfields.CategoryTypeLabel !== "" &&
      initialfields.CourseTypeLabel !== "" &&
      initialfields.courseSubCategory !== ""
    ) {
      AxiosInstance.post("api/all/getSubjects", {
        category: initialfields?.CategoryTypeLabel,
        course_name: initialfields?.CourseTypeLabel,
        sub_category: initialfields?.courseSubCategory,
        type: 0,
      })
        .then((res) => {
          // console.log(res, "use effect");
          if (res.data.status === true) {
            if (res.data.data.length > 0) {
              const subject = res.data.data.map((item, index) => ({
                value: item.subject,
                label: item.subject,
                pk: item.id,
              }));
              setSubjectGroupName(subject);
            } else {
              setSubjectGroupName([]);
            }
          } else {
            setSubjectGroupName([]);
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [initialfields.courseGrouping]);
  useEffect(() => {
    const search = "";
    AxiosInstance.post("api/book/author/list", {
      search: search,
    })
      .then((res) => {
        const author = res.data?.data?.map((item, index) => ({
          value: item.id,
          label: item.author_name,
        }));
        setAuthorList(author);
      })
      .catch((error) => {
        return error;
      });
  }, []);
  useEffect(() => {
    const search = "";
    AxiosInstance.post("api/book/publisher/list", {
      search: search,
    })
      .then((res) => {
        const publisher = res.data?.data?.map((item, index) => ({
          value: item.id,
          label: item.publisher_name,
        }));
        setPublisherList(publisher);
      })
      .catch((error) => {
        return error;
      });
  }, []);
  useEffect(() => {
    const search = "";
    AxiosInstance.post("api/book/tag/list", {
      search: search,
    })
      .then((res) => {
        const tags = res.data?.data
          ?.map((item, index) => ({
            value: item.id,
            label: item.tag_name,
          }))
          .filter((tag) => tag.value !== 6);
        setTagsList(tags);
      })
      .catch((error) => {
        return error;
      });
  }, []);
  // useEffect(() => {
  //     const storedImageURLs = JSON.parse(localStorage.getItem("imageURLS")) || [];
  //     setImageURLs(storedImageURLs);
  // }, []);
  // useEffect(() => {
  //     localStorage.setItem("imageURLS", JSON.stringify(imageURLS));
  // }, [imageURLS]);
  // useEffect(() => {
  //     if (images.length < 1) return;
  //     const newImageUrls = [];
  //     images.forEach((image) => newImageUrls.push(URL.createObjectURL(image)));
  //     setImageURLs(newImageUrls);
  // }, [images]);
  const validateFocusCommentSection = (COMSECFO) => {
    const youtubeRegex =
      /^(https?:\/\/(www\.)?youtube\.com\/(watch\?v=|shorts\/|embed\/)[a-zA-Z0-9_-]+(\?.*)?)$|^(https?:\/\/youtu\.be\/[a-zA-Z0-9_-]+(\?.*)?)$/;
    if (!COMSECFO.ebook) {
      ebook_ref.current.focus();
    }
    if (
      !COMSECFO.bookName ||
      (COMSECFO.bookName && COMSECFO.bookName?.trim() === "")
    ) {
      book_name_ref.current.focus();
    }
    // else if (COMSECFO.isbnNumber && COMSECFO.isbnNumber?.length !== 10 && COMSECFO.isbnNumber?.length !== 13) {
    //   isbn_ref.current.focus();
    // }
    else if (
      !COMSECFO.isbnNumber ||
      (COMSECFO.isbnNumber &&
        COMSECFO.isbnNumber?.trim() === "" &&
        COMSECFO.ebook != 1)
    ) {
      isbn_ref.current.focus();
    } else if (!COMSECFO.tnoPage) {
      tnopage_ref.current.focus();
    } else if (COMSECFO.filePdfName === false) {
      answer_sheet_ref.current.focus();
    }

    // if (
    //   initialfields.preview_path &&
    //   !initialfields.preview_path.toLowerCase().endsWith(".pdf")
    // ) {
    //   answer_sheet_ref.current.focus();
    // }
    // else if (!COMSECFO.iframe) {
    //   iframe_ref.current.focus();
    // }
    // else if (COMSECFO.iframe && !validateIframeTag(COMSECFO.iframe)) {
    //   iframe_ref.current.focus();
    // }
    else if (
      (!COMSECFO.bookPathUrl && COMSECFO.ebook == 1) ||
      (COMSECFO.bookPathUrl &&
        COMSECFO.bookPathUrl.trim().toLowerCase().endsWith(".pdf") &&
        COMSECFO.ebook == 1)
    ) {
      book_path_url_ref.current.focus();
    } else if (!COMSECFO.tagLine) {
      tagLine_ref.current.focus();
    } else if (!COMSECFO.description) {
      description_ref.current.focus();
    } else if (!COMSECFO.stockCount && COMSECFO.ebook == 0) {
      stock_count_ref.current.focus();
    } else if (!COMSECFO.price) {
      price_ref.current.focus();
    } else if (COMSECFO.price && parseInt(COMSECFO.price) < 0) {
      price_ref.current.focus();
    } else if (
      !COMSECFO.price ||
      COMSECFO.price <= 0 ||
      COMSECFO.price > 999999
    ) {
      price_ref.current.focus();
    } else if (
      !COMSECFO.offerPer ||
      parseInt(COMSECFO.offerPer) < 0 ||
      parseInt(COMSECFO.offerPer) > 99
    ) {
      offerPer_ref.current.focus();
    } else if (!COMSECFO.categoryGrouping) {
      category_ref.current.focus();
    } else if (!COMSECFO.courseGrouping) {
      course_ref.current.focus();
    } else if (!COMSECFO.subjectGrouping) {
      subject_ref.current.focus();
    } else if (!COMSECFO.mediumTypeLabel) {
      medium_ref.current.focus();
    } else if (
      !COMSECFO.iframe ||
      initialfields.iframe.trim() === "<iframe></iframe>" ||
      !youtubeRegex.test(initialfields.iframe)
    ) {
      youtube_ref.current.focus();
    } else if (COMSECFO.seriesGrouping.length === 0) {
      seriesTag_ref.current.focus();
    } else if (!COMSECFO.length && COMSECFO.ebook == 0) {
      length_ref.current.focus();
    } else if (!COMSECFO.width && COMSECFO.ebook == 0) {
      width_ref.current.focus();
    } else if (!COMSECFO.thickness && COMSECFO.ebook == 0) {
      thickness_ref.current.focus();
    } else if (!COMSECFO.weight && COMSECFO.ebook == 0) {
      weight_ref.current.focus();
    } else if (
      COMSECFO.weight &&
      parseInt(COMSECFO.weight) <= 0 &&
      !isFloat(COMSECFO.weight)
    ) {
      weight_ref.current.focus();
    } else if (
      COMSECFO.weight &&
      isFloat(COMSECFO.weight) &&
      !/^\d+\.\d{1,3}$|^\d+$/.test(COMSECFO.weight)
    ) {
      weight_ref.current.focus();
    } else if (COMSECFO.tagsGrouping.length === 0) {
      tagsGrouping_ref.current.focus();
    } else if (
      !COMSECFO.upload_image_path ||
      (COMSECFO.upload_image_path.filter((img) => img?.is_valid !== 0)
        .length === 0 &&
        COMSECFO.ebook == 0)
    ) {
      upload_image_ref.current.focus();
    }
  };
  function isFloat(x) {
    return !!(x % 1);
  }

  const validateFields = (data) => {
    const errors = {};


    // Validate Price & Numeric Fields (Max 5 digits)
    const numRegex = /^[0-9]{1,5}$/;
    ["tnoPage", "price", "length", "width", "thickness"].forEach((field) => {
      if (data[field] && !numRegex.test(data[field])) {
        errors[field] = "Value cannot exceed 5 digits";
      }
    });
    // Validate Offer Percentage (0-100)
    const offerRegex = /^[0-9]{1,2}$/;
    if (data.offerPer && !offerRegex.test(data.offerPer)) {
      errors.offerPer = "Offer percentage must be between 0 and 100";
    }
    if (
      isFreeBook != 1 &&
      (!data.price || data.price <= 0 || data.price > 999999)
    ) {
      errors.price = "Please enter a valid MRP";
    }

    if (data.filePdfName === false) {
      errors.preview_path =
        "Only PDF files are allowed. Please upload a valid PDF under 10 MB";
    }

    const weightStr = String(data.weight || "");
    if (parseFloat(weightStr) === 0 && data.ebook !== 1) {
      errors.weight = "Weight cannot be zero";
    }
    // Validate Weight (Max 5 digits before decimal, 3 after)
    const weightRegex = /^\d{0,5}(\.\d{1,3})?$/;
    if (data.ebook !== 1) {
      if (!data.weight) {
        if (!weightRegex.test(data.weight)) {
          errors.weight = "Invalid weight format";
        } else if (parseFloat(data.weight) < 0) {
          errors.weight = "Value cannot be negative";
        } else if (
          data.weight.includes(".") &&
          data.weight.split(".")[0]?.length > 5
        ) {
          errors.weight = "Weight cannot exceed 5 digits before the decimal";
        } else if (
          data.weight.includes(".") &&
          data.weight.split(".")[1]?.length > 3
        ) {
          errors.weight = "Weight cannot have more than 3 decimal places";
        }
      }

      if (!data.ebook && data.ebook === "") {
        errors.ebook = "Please select a e-book";
      }

      if (!data.bookName || (data.bookName && data.bookName?.trim() === "")) {
        errors.bookName = "Please enter the book name";
      }
    }

    // if (!data.authorGrouping) {
    //     errors.authorGrouping = "Please select an author";
    // }
    // if (!data.publisheGrouping) {
    //     errors.publisheGrouping = "Please select an publisher";
    // }
    // if (data.isbnNumber) {
    //   if (data.isbnNumber.length !== 10 && data.isbnNumber.length !== 13) {
    //     errors.isbnNumber = "ISBN number must be either 10 or 13 digits";
    //   }
    // }

    // Check if ISBN number is required
    if (
      !data.isbnNumber ||
      (data.isbnNumber &&
        data.isbnNumber?.trim() === "" &&
        initialfields.ebook == 0)
    ) {
      errors.isbnNumber = "Please enter the ISBN number";
    }
    if (data.tnoPage == "") {
      errors.tnoPage = "Please enter the total number of pages";
    }
    // else if (
    //   data.tnoPage &&
    //   (/^0(?!$)/.test(data.tnoPage) || parseInt(data.tnoPage) <= 0)
    // ) {
    //   errors.tnoPage =
    //     "Total number of pages must be a positive number and not start with negative";
    // }
    // if (data.preview_path === "") {
    //   errors.preview_path = "Please upload a PDF file less than 2MB.";
    // }
    // if (data.iframe === "") {
    //   errors.iframe = "Please enter a valid Youtube URL";
    // }
    // if (data.iframe && !validateIframeTag(data.iframe)) {
    //   errors.iframe = "Please enter a valid iframe URL.";
    // }
    if (data.bookPathUrl === "" && initialfields.ebook == 1) {
      errors.bookPathUrl = "Please enter the book path URL";
    } else if (
      initialfields.ebook == 1 &&
      (!data.bookPathUrl ||
        !data.bookPathUrl.trim().toLowerCase().endsWith(".pdf"))
    ) {
      errors.bookPathUrl = "Only PDF URLs are allowed";
    }

    if (data.description === "") {
      errors.description = "Please enter the description";
    }
    if (data.stockCount === "" && initialfields.ebook == 0) {
      errors.stockCount = "Please enter the stock count";
    }
    // else if (data.stockCount && parseInt(data.stockCount) < 0) {
    //   errors.stockCount = "Stock count must be a positive number";
    // } else if (
    //   (data.stockCount && /^0(?!$)/.test(data.stockCount)) ||
    //   parseInt(data.stockCount) === 0
    // ) {
    //   errors.stockCount = "Stock count cannot start with zero or be zero";
    // }
    if (isFreeBook === 0) {
      if (data.price === "") {
        errors.price = "Please enter the price";
      }
      // if (data.price && parseInt(data.price) < 0) {
      //   errors.offerPer = "Please enter valid price";
      // }
      if (data.offerPer === "") {
        errors.offerPer = "Please enter the offer percentage";
      }
    }
    if (data.tagLine === "") {
      errors.tagLine = "Please enter the short description";
    }
    // if (
    //   data.offerPer &&
    //   (parseInt(data.offerPer) < 0 || parseInt(data.offerPer) > 99)
    // ) {
    //   errors.offerPer = "Please enter valid offer percentage";
    // }
    if (data.categoryGrouping === "") {
      errors.categoryGrouping = "Please select a category";
    }
    if (data.courseGrouping === "") {
      errors.courseGrouping = "Please select a course";
    }
    if (data.subjectGrouping === "") {
      errors.subjectGrouping = "Please select a subject";
    }
    if (data.mediumGrouping === "") {
      errors.mediumGrouping = "Please select a medium";
    }

    if ((data.length || "").trim() === "" && initialfields.ebook == 0) {
      errors.length = "Please enter the length";
    }
    if ((data.width || "").trim() === "" && initialfields.ebook == 0) {
      errors.width = "Please enter the width";
    }
    if ((data.thickness || "").trim() === "" && initialfields.ebook == 0) {
      errors.thickness = "Please enter the thickness";
    }
    if (data.weight === "" && initialfields.ebook == 0) {
      errors.weight = "Please enter the valid weight";
    }
    //  else if (
    //   data.weight &&
    //   parseInt(data.weight) <= 0 &&
    //   !isFloat(data.weight)
    // ) {
    //   errors.weight = "Please enter a valid weight";
    // } else if (
    //   data.weight &&
    //   isFloat(data.weight) &&
    //   !/^\d+\.\d{1,3}$|^\d+$/.test(data.weight)
    // ) {
    //   errors.weight =
    //     "Please enter a valid weight with up to 3 decimal precision";
    // }
    if (data.tagsGrouping.length === 0) {
      errors.tagsGrouping = "Please select or enter new tags";
    }
    if (data.seriesGrouping?.length === 0) {
      errors.seriesGrouping = "Please select book series ";
    }

    if (
      !data.upload_image_path ||
      (data.upload_image_path.filter((img) => img?.is_valid !== 0).length ===
        0 &&
        initialfields.ebook != 1)
    ) {
      errors.upload_image_path = "Please upload atleast one image";
    }
    validateFocusCommentSection(data);
    return errors;
  };
  const cleanIframeUrl = (iframeString) => {
    if (!iframeString) return "";
    const match = iframeString.match(/src="([^"]*)"/);
    return match ? match[1] : iframeString; // If match found, return extracted src; otherwise, return as-is
  };
  const handleIframeChange = (e) => {
    let value = e.target.value.trim();
    let errorMessage = "";
    // Regex to match:
    // 1. YouTube embed URL (https://www.youtube.com/embed/...)
    // 2. YouTube share URL (https://youtu.be/...)
    // 3. Valid <iframe> tag containing a YouTube embed URL
    const youtubeRegex =
      /^(https?:\/\/(www\.)?youtube\.com\/(watch\?v=|shorts\/|embed\/)[a-zA-Z0-9_-]+(\?.*)?)$|^(https?:\/\/youtu\.be\/[a-zA-Z0-9_-]+(\?.*)?)$/;
    // Validate YouTube URL or iframe tag
    // if (!value) {
    //   errorMessage = "YouTube URL cannot be empty";
    // } else
    if (!youtubeRegex.test(value)) {
      errorMessage = "Please enter a valid YouTube URL";
    } else {
      // If input is a YouTube short URL (youtu.be), convert it to an embed URL
      const youtuMatch = value.match(
        /^https?:\/\/youtu\.be\/([a-zA-Z0-9_-]+)(\?.*)?$/
      );
      if (youtuMatch) {
        value = `https://www.youtube.com/embed/${youtuMatch[1]}`;
      }
    }

    // Update state
    setInitialfields((prevFields) => ({
      ...prevFields,
      iframe: value,
    }));

    // Update error state
    setError((prev) => ({
      ...prev,
      iframe: errorMessage || undefined, // Remove error if valid
    }));
  };

  const handleSubmit = () => {
    const err_bnh = validateFields(initialfields);
    // Validate iframe only if a value is entered
    if (initialfields.iframe.trim()) {
      const youtubeRegex =
        /^(https?:\/\/(www\.)?youtube\.com\/(watch\?v=|shorts\/|embed\/)[a-zA-Z0-9_-]+(\?.*)?)$|^(https?:\/\/youtu\.be\/[a-zA-Z0-9_-]+(\?.*)?)$/;
      // Check if input is just an empty iframe tag or invalid format
      if (
        initialfields.iframe.trim() === "<iframe></iframe>" ||
        !youtubeRegex.test(initialfields.iframe)
      ) {
        err_bnh.iframe = "Please enter a valid Youtube URL";
      }
    }
    setError(err_bnh);

    if (Object.keys(err_bnh).length === 0) {
      if (initialfields?.tnoPage?.length > 5) {
        setError({
          ...error,
          tnoPage: "Value cannot exceed 5 digits",
        });
        return;
      }

      try {
        if (id) {
          let updateCoupon;
          // const imagesList = initialfields.upload_image_path
          //   ?.filter((img) => img.is_valid !== 0) // ✅ Filter out deleted images
          //   .map((path, index) => ({
          //     id: "",
          //     original_book_image_path:
          //       initialfields.upload_image_original_path?.[index] ||
          //       path.original_book_image_path ||
          //       "",
          //     book_image_path: path.path || path.book_image_path,
          //     is_valid: 1,
          //   }));
          const activeImages = initialfields.upload_image_path?.filter(
            (img) => img.is_valid !== 0
          );
          const deletedAPIImages = initialfields.upload_image_path
            ?.filter((img) => img.is_valid === 0 && img.isFromAPI)
            .map((img) => ({
              id: img.image_id,
              is_valid: 0,
            }));

          const uploadedImages = activeImages.map((img, index) => ({
            id: img.image_id || "",
            original_book_image_path:
              initialfields.upload_image_original_path?.[index] ||
              img.originalname ||
              "",
            book_image_path: img.path || img.book_image_path,
            is_valid: 1,
          }));

          const imagesList = [...uploadedImages, ...deletedAPIImages];
          // Combine all user entries
          if (initialfields.ebook == 1) {
            updateCoupon = {
              id: parseInt(id),
              is_set: 0,
              book_ids: null,
              book_title: initialfields.bookName,
              author_id: initialfields.authorGrouping
                ? typeof initialfields.authorGrouping === "number"
                  ? initialfields.authorGrouping
                  : ""
                : 0,
              author_name: initialfields.authorLabel,
              publisher_id: initialfields.publisheGrouping
                ? typeof initialfields.publisheGrouping === "number"
                  ? initialfields.publisheGrouping
                  : ""
                : 0,
              price: initialfields.price ? parseInt(initialfields.price) : 0,
              offer_percentage: initialfields.offerPer
                ? parseInt(initialfields.offerPer)
                : 0,
              is_free_book: isFreeBook,
              is_combo_offer: 0,
              publisher_name: initialfields.publisherLabel,
              isbn_no: initialfields.isbnNumber || "",
              stock_count: parseInt(initialfields.stockCount),
              category_id: initialfields.categoryGrouping || 0,
              category_name: initialfields.CategoryTypeLabel || null,
              group_course_id: initialfields.courseGrouping || 0,
              group_course_name: initialfields.CourseTypeLabel || null,
              subject_id: initialfields.subjectGrouping || 0,
              subject_name: initialfields.subjectTypeLabel || null,
              tag_line: initialfields.tagLine,
              medium:
                initialfields.mediumGrouping !== undefined
                  ? initialfields.mediumGrouping == 0
                    ? initialfields.mediumGrouping
                    : initialfields.mediumGrouping
                  : "",
              // medium: initialfields.mediumGrouping || null,
              book_type: parseInt(initialfields.seriesGrouping),
              tags:
                initialfields.tagsGrouping.length > 0 &&
                initialfields.tagsGrouping.map((id, index) => ({
                  id,
                  tag_name: initialfields.tagsLabel[index],
                })),
              dimension: null,
              weight: null,
              description: initialfields.description,
              total_pages: parseInt(initialfields.tnoPage),
              iframe: initialfields.iframe.trim()
                ? cleanIframeUrl(initialfields.iframe)
                : null,
              // iframe: cleanIframeUrl(initialfields.iframe),
              // iframe: initialfields.iframe,
              // iframe: iframeURL || null,
              // iframe: initialfields.iframe
              //   ? `<iframe src="${initialfields.iframe}" allowfullscreen></iframe>` // Wrap in iframe tag
              //   : "",
              ebook_url: initialfields.bookPathUrl,
              is_ebook: parseInt(initialfields.ebook),
              preview_path: initialfields.preview_path,
              original_preview_path: initialfields.original_preview_path,
              is_visible: initialfields.visibleUser,
              images: imagesList,
              created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
              created_by: userid,
            };
          } else {
            updateCoupon = {
              id: parseInt(id),
              is_set: 0,
              book_ids: null,
              book_title: initialfields.bookName,
              author_id: initialfields.authorGrouping
                ? typeof initialfields.authorGrouping === "number"
                  ? initialfields.authorGrouping
                  : ""
                : 0,
              author_name: initialfields.authorLabel,
              publisher_id: initialfields.publisheGrouping
                ? typeof initialfields.publisheGrouping === "number"
                  ? initialfields.publisheGrouping
                  : ""
                : 0,
              publisher_name: initialfields.publisherLabel,
              isbn_no: initialfields.isbnNumber || "",
              price: initialfields.price ? parseInt(initialfields.price) : 0,
              offer_percentage: initialfields.offerPer
                ? parseInt(initialfields.offerPer)
                : 0,
              is_free_book: isFreeBook,
              is_combo_offer: 0,
              is_stock: isStockChanged ? 1 : 0,
              stock_count: isStockChanged
                ? parseInt(initialfields.addCount)
                : parseInt(initialfields.stockCount),
              category_id: initialfields.categoryGrouping || 0,
              category_name: initialfields.CategoryTypeLabel || null,
              group_course_id: initialfields.courseGrouping || 0,
              group_course_name: initialfields.CourseTypeLabel || null,
              subject_id: initialfields.subjectGrouping || 0,
              subject_name: initialfields.subjectTypeLabel || null,
              medium:
                initialfields.mediumGrouping !== undefined
                  ? initialfields.mediumGrouping == 0
                    ? initialfields.mediumGrouping
                    : initialfields.mediumGrouping
                  : "",
              // medium: initialfields.mediumGrouping || null,
              book_type: parseInt(initialfields.seriesGrouping),
              tags:
                initialfields.tagsGrouping.length > 0 &&
                initialfields.tagsGrouping.map((id, index) => ({
                  id,
                  tag_name: initialfields.tagsLabel[index],
                })),
              tag_line: initialfields.tagLine,
              dimension: `${initialfields.length}x${initialfields.width}x${initialfields.thickness}`,
              weight: Number(initialfields.weight),
              description: initialfields.description,
              total_pages: parseInt(initialfields.tnoPage),
              iframe: initialfields.iframe.trim()
                ? cleanIframeUrl(initialfields.iframe)
                : null,
              // iframe: cleanIframeUrl(initialfields.iframe),
              // iframe: initialfields.iframe,
              // iframe: iframeURL || null,
              // iframe: initialfields.iframe
              //   ? `<iframe src="${initialfields.iframe}" allowfullscreen></iframe>` // Wrap in iframe tag
              //   : "",
              ebook_url: initialfields.bookPathUrl,
              is_ebook: parseInt(initialfields.ebook),
              preview_path: initialfields.preview_path,
              original_preview_path: initialfields.original_preview_path,
              is_visible: initialfields.visibleUser,
              images: imagesList,
              created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
              created_by: userid,
            };
          }

          AxiosInstance.post(`api/book/add`, updateCoupon)
            .then((res) => {
              setIsStockChanged(false);
              if (res.data.status) {
                toast.success(res.data.message);
                navigate(-1);
              } else {
                toast.error(res.data.message);
              }
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          const images = initialfields.upload_image_path
            ?.filter((img) => img.is_valid !== 0) // ✅ Filter out deleted images
            .map((path, index) => ({
              id: "",
              original_book_image_path:
                initialfields.upload_image_original_path?.[index] ||
                path.original_book_image_path ||
                "",
              book_image_path: path.path || path.book_image_path,
              is_valid: 1,
            }));
          let updateCoupon;

          if (initialfields.ebook == 1) {
            updateCoupon = {
              id: "",
              is_set: 0,
              book_ids: null,
              book_title: initialfields.bookName,
              author_id: initialfields.authorGrouping
                ? typeof initialfields.authorGrouping === "number"
                  ? initialfields.authorGrouping
                  : ""
                : 0,
              author_name: initialfields.authorLabel,
              publisher_id: initialfields.publisheGrouping
                ? typeof initialfields.publisheGrouping === "number"
                  ? initialfields.publisheGrouping
                  : ""
                : 0,
              publisher_name: initialfields.publisherLabel || null,
              isbn_no: initialfields.isbnNumber || "",
              stock_count: parseInt(initialfields.stockCount),
              category_id: initialfields.categoryGrouping || 0,
              category_name: initialfields.CategoryTypeLabel || null,
              group_course_id: initialfields.courseGrouping || 0,
              group_course_name: initialfields.CourseTypeLabel || null,
              subject_id: initialfields.subjectGrouping || 0,
              subject_name: initialfields.subjectTypeLabel || null,
              price: initialfields.price ? parseInt(initialfields.price) : 0,
              offer_percentage: initialfields.offerPer
                ? parseInt(initialfields.offerPer)
                : 0,
              is_free_book: isFreeBook,
              is_combo_offer: 0,
              medium:
                initialfields.mediumGrouping !== undefined
                  ? initialfields.mediumGrouping == 0
                    ? initialfields.mediumGrouping
                    : initialfields.mediumGrouping
                  : "",
              // medium: initialfields.mediumGrouping || null,
              tag_line: initialfields.tagLine,
              book_type: parseInt(initialfields.seriesGrouping),
              // tags: initialfields.tagsGrouping.length > 0 && initialfields.tagsGrouping.map((id, index) => ({
              //     id,
              //     tag_name: initialfields.tagsLabel[index],
              // })),
              tags:
                initialfields.tagsGrouping.length > 0
                  ? initialfields.tagsGrouping.map((id, index) => ({
                      id: id || "", // Null for new tags
                      tag_name: initialfields.tagsLabel[index],
                    }))
                  : [],
              dimension: null,
              weight: null,
              description: initialfields.description,
              total_pages: parseInt(initialfields.tnoPage),
              iframe: initialfields.iframe.trim()
                ? cleanIframeUrl(initialfields.iframe)
                : null,
              // iframe: cleanIframeUrl(initialfields.iframe),
              // iframe: initialfields.iframe || null,
              // iframe: iframeURL || null,
              // iframe: initialfields.iframe
              //   ? `<iframe src="${initialfields.iframe}" allowfullscreen></iframe>` // Wrap in iframe tag
              //   : "",
              ebook_url: initialfields.bookPathUrl,
              is_ebook: parseInt(initialfields.ebook),
              preview_path: initialfields.preview_path,
              original_preview_path: initialfields.original_preview_path,
              is_visible: initialfields.visibleUser,
              is_visible: 1,
              images: images,
              created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
              created_by: userid,
            };
          }

          setError({
            ...error,
            tagsGrouping: "",
          });

          // if (
          //   initialfields?.isbnNumber?.length > 13 ||
          //   initialfields.isbnNumber.length < 10 && initialfields.ebook != 1
          // ) {
          //   setError({
          //     ...error,
          //     isbnNumber: "ISBN number must be either 10 or 13 digits",
          //   });
          //   return;
          // }
          if (initialfields?.tnoPage?.length > 5) {
            setError({
              ...error,
              tnoPage: "Value cannot exceed 5 digits",
            });
            return;
          } else {
            updateCoupon = {
              id: "",
              is_set: 0,
              book_ids: null,
              book_title: initialfields.bookName,
              author_id: initialfields.authorGrouping
                ? typeof initialfields.authorGrouping === "number"
                  ? initialfields.authorGrouping
                  : ""
                : 0,
              author_name: initialfields.authorLabel,
              publisher_id: initialfields.publisheGrouping
                ? typeof initialfields.publisheGrouping === "number"
                  ? initialfields.publisheGrouping
                  : ""
                : 0,
              publisher_name: initialfields.publisherLabel || null,
              isbn_no: initialfields.isbnNumber || "",
              price: initialfields.price ? parseInt(initialfields.price) : 0,
              offer_percentage: initialfields.offerPer
                ? parseInt(initialfields.offerPer)
                : 0,
              stock_count: parseInt(initialfields.stockCount),
              category_id: initialfields.categoryGrouping || 0,
              category_name: initialfields.CategoryTypeLabel || null,
              group_course_id: initialfields.courseGrouping || 0,
              group_course_name: initialfields.CourseTypeLabel || null,
              subject_id: initialfields.subjectGrouping || 0,
              subject_name: initialfields.subjectTypeLabel || null,
              medium:
                initialfields.mediumGrouping !== undefined
                  ? initialfields.mediumGrouping == 0
                    ? initialfields.mediumGrouping
                    : initialfields.mediumGrouping
                  : "",
              // medium: initialfields.mediumGrouping || null,
              tag_line: initialfields.tagLine,
              book_type: parseInt(initialfields.seriesGrouping),
              tags:
                initialfields.tagsGrouping.length > 0 &&
                initialfields.tagsGrouping.map((id, index) => ({
                  id,
                  tag_name: initialfields.tagsLabel[index],
                })),
              dimension: `${initialfields.length}x${initialfields.width}x${initialfields.thickness}`,
              weight: Number(initialfields.weight),
              description: initialfields.description,
              total_pages: parseInt(initialfields.tnoPage),
              iframe: initialfields.iframe.trim()
                ? cleanIframeUrl(initialfields.iframe)
                : null,
              // iframe: cleanIframeUrl(initialfields.iframe),
              // iframe: initialfields.iframe,
              // iframe: initialfields.iframe
              //   ? `<iframe src="${initialfields.iframe}" allowfullscreen></iframe>` // Wrap in iframe tag
              //   : "",
              // iframe: iframeURL || null,
              ebook_url: initialfields.bookPathUrl,
              is_ebook: parseInt(initialfields.ebook),
              preview_path: initialfields.preview_path,
              original_preview_path: initialfields.original_preview_path,
              is_visible: initialfields.visibleUser,
              is_visible: 1,
              images: images,
              created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
              created_by: userid,
              is_free_book: isFreeBook,
              is_combo_offer: 0,
            };

            AxiosInstance.post(`api/book/add`, updateCoupon)
              .then((res) => {
                if (res.data.status) {
                  toast.success(res.data.message);
                  navigate("/studyMaterials/Books/list");
                } else {
                  toast.error(res.data.message);
                }
              })
              .catch((error) => {
                return error;
              });
          }
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      setError(err_bnh);
    }
  };

  const navigateToPreviousScreen = () => {
    // navigate("/studyMaterials/Books/list");
    navigate(-1);
  };
  const Tagsitems = [
    {
      value: "0",
      label: "A",
    },
    {
      value: "1",
      label: "B",
    },
    {
      value: "2",
      label: "GB",
    },
    {
      value: "3",
      label: "QB",
    },
    {
      value: "4",
      label: "PYQ",
    },
  ];
  const handleDownload = (url, filename) => {
    axios
      .get(`${ImageUrlPrefix}/${initialfields.preview_path}`, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
      })
      .catch((error) => {
        console.error("Download failed:", error);
      });
  };
  return (
    <div className={`${createInfo.CourseInfoSec} BathHeader global_container`}>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">{id ? "Edit Book" : "Add New Book"}</h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={navigateToPreviousScreen}
                className="secondaryButton "
                variant="secondary"
              >
                {id ? "Back to View Book" : "Back to Books"}
              </Link>
            </li>
            <li class="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSubmit}
                className="primaryButton text-center "
                variant="primary"
              >
                Save Book
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <fieldset className="mt-3">
        <legend className="w-auto">Book Type</legend>
        <form className="row g-3">
          <div className="col-md-6">
            <label htmlFor="ebook" className="form-label confirm_value">
              Is this an eBook?
            </label>

            <div>
              <input
                ref={ebook_ref}
                className={`shadow-none input-font-size  ${createInfo.checkbox_radio}`}
                // isDisabled={id ? true : false}
                // disabled={!!id}
                type="radio"
                checked={initialfields.ebook == 1 ? true : false}
                id="yes"
                name="ebook"
                value={1}
                onChange={handleChange}
                disabled={
                  (id && initialfields?.book_in_set === 1) ||
                  initialfields?.book_in_set === 0
                }
              />
              <label
                htmlFor="yes"
                className={`${createInfo.margin_right} form-label confirm_value`}
              >
                Yes
              </label>

              <input
                ref={ebook_ref}
                className={`shadow-none input-font-size  ${createInfo.checkbox_radio}`}
                //  isDisabled={id ? true : false}
                // disabled={!!id}
                type="radio"
                id="no"
                name="ebook"
                value={0}
                checked={initialfields.ebook == 0 ? true : false}
                onChange={handleChange}
                disabled={
                  (id && initialfields?.book_in_set === 1) ||
                  initialfields?.book_in_set === 0
                }
              />
              <label htmlFor="no" className="form-label confirm_value">
                No
              </label>
            </div>
            {error.ebook && (
              <small className="error_message">{error.ebook}</small>
            )}
          </div>
          <div className="col-md-6">
            <label htmlFor="freeBook" className="form-label confirm_value">
              Is this a free book?
            </label>

            <div>
              <input
                className={`shadow-none input-font-size  ${createInfo.checkbox_radio}`}
                type="radio"
                checked={isFreeBook === 1}
                id="freeBook_yes"
                name="freeBook"
                value={1}
                onChange={() => {
                  setIsFreeBook(1);
                  setInitialfields({
                    ...initialfields,
                    price: "",
                    offerPer: "",
                  });
                }}
                disabled={id && (isFreeBook === 1 || isFreeBook === 0)}
              />
              <label
                htmlFor="freeBook_yes"
                className={`${createInfo.margin_right} form-label confirm_value`}
              >
                Yes
              </label>

              <input
                className={`shadow-none input-font-size  ${createInfo.checkbox_radio}`}
                type="radio"
                id="freeBook_no"
                name="freeBook"
                value={0}
                checked={isFreeBook === 0}
                onChange={() => {
                  setIsFreeBook(0);
                  setInitialfields({
                    ...initialfields,
                    price: "",
                    offerPer: "",
                  });
                }}
                disabled={id && (isFreeBook === 1 || isFreeBook === 0)}
              />
              <label htmlFor="freeBook_no" className="form-label confirm_value">
                No
              </label>
            </div>
          </div>
          {id && (
            <div className="col-md-6">
              <label htmlFor="visibleUser" className="form-label confirm_value">
                Visible to Users
              </label>

              <div>
                <input
                  ref={visible_ref}
                  className={`shadow-none input-font-size  ${createInfo.checkbox_radio}`}
                  // isDisabled={id ? true : false}
                  // disabled={!!id}
                  type="radio"
                  checked={initialfields.visibleUser == 1 ? true : false}
                  id="Visible_to_Users_yes"
                  name="visibleUser"
                  value={1}
                  onChange={handleChange}
                />
                <label
                  htmlFor="Visible_to_Users_yes"
                  className={`${createInfo.margin_right} form-label confirm_value`}
                >
                  Yes
                </label>

                <input
                  ref={visible_ref}
                  className={`shadow-none input-font-size  ${createInfo.checkbox_radio}`}
                  //  isDisabled={id ? true : false}
                  // disabled={!!id}
                  type="radio"
                  id="Visible_to_Users_no"
                  name="visibleUser"
                  value={0}
                  checked={initialfields.visibleUser == 0 ? true : false}
                  onChange={handleChange}
                />
                <label
                  htmlFor="Visible_to_Users_no"
                  className="form-label confirm_value"
                >
                  No
                </label>
              </div>
              {error.visibleUser && (
                <small className="error_message">{error.visibleUser}</small>
              )}
            </div>
          )}
        </form>
      </fieldset>
      <fieldset className="mt-3">
        <legend className="w-auto">Book Details</legend>
        <form className="row g-3">
          <div class="col-md-6">
            <label for="bookName" class="form-label confirm_value ">
              Book Name
            </label>
            <input
              ref={book_name_ref}
              class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
              type="text"
              id="bookName"
              name="bookName"
              placeholder="Enter the book name"
              value={initialfields.bookName}
              onChange={handleChange}
            />
            {error.bookName && (
              <small className="error_message">{error.bookName}</small>
            )}
          </div>
          <div className="col-md-6">
            <label for="authorGrouping" class="form-label confirm_value ">
              Author
            </label>
            <Creatable
              ref={author_ref}
              className={`shadow-none input-font-size `}
              name="authorGrouping"
              value={
                initialfields.authorLabel && initialfields.authorGrouping
                  ? {
                      value: initialfields.authorGrouping,
                      label: initialfields.authorLabel,
                    }
                  : initialfields.authorLabel
                  ? { value: "", label: initialfields.authorLabel }
                  : null
              }
              onChange={(option) =>
                handlechangeSelectDropdown(option, "authorGrouping")
              }
              isClearable={true}
              options={authorList}
              isSearchable={true}
              placeholder="Select or enter new author"
              maxMenuHeight={200}
              filterOption={(option, searchText) =>
                option?.label?.toLowerCase()?.includes(searchText.toLowerCase())
              }
              styles={customStyles}
              formatCreateLabel={(inputValue) => `Add New : ${inputValue}`}
            />
            {error.authorGrouping && (
              <small className="error_message">{error.authorGrouping}</small>
            )}
          </div>
          <div className="col-md-6">
            <label for="publisheGrouping" class="form-label confirm_value ">
              Publisher
            </label>
            {/* <Select
                            ref={category_ref}
                            className={`shadow-none input-font-size `}
                            name="publisher"
                            value={
                                Array.isArray(initialfields.publisher) && initialfields.publisher.length > 0
                                    ? initialfields.publisher.map((id, index) => ({
                                        value: id,
                                        label: initialfields.emailLabel[index],
                                        user_id: initialfields.userIds[index]
                                    }))
                                    : []
                            }
                            onChange={(selectedOptions) =>
                                handlechangeSelectDropdown(selectedOptions, "publisher")
                            }
                            options={allCategories}
                            isMulti
                            isSearchable={true}
                            placeholder="Select publisher"
                            maxMenuHeight={200}
                            filterOption={(option, searchText) =>
                                option.label?.toLowerCase().includes(searchText?.toLowerCase())
                            }
                            styles={customStyles}
                        /> */}
            <Creatable
              ref={pulisher_ref}
              className={`shadow-none input-font-size `}
              // isDisabled={id ? true : false}
              name="publisheGrouping"
              // value={
              //     initialfields.publisherLabel !== null &&
              //         initialfields.publisheGrouping !== ""
              //         ? {
              //             value: initialfields.publisheGrouping,
              //             label: initialfields.publisherLabel,
              //         }
              //         : null
              // }

              value={
                initialfields.publisherLabel && initialfields.publisheGrouping
                  ? {
                      value: initialfields.publisheGrouping,
                      label: initialfields.publisherLabel,
                    }
                  : initialfields.publisherLabel
                  ? { value: "", label: initialfields.publisherLabel }
                  : null
              }
              onChange={(option) =>
                handlechangeSelectDropdown(option, "publisheGrouping")
              }
              isClearable={true}
              options={publisherList}
              isSearchable={true} // Enables search functionality
              placeholder="Select or enter new publisher"
              maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
              filterOption={(option, searchText) =>
                option?.label?.toLowerCase()?.includes(searchText.toLowerCase())
              } // Filter options based on the search text
              styles={customStyles} // Apply custom styles her
              formatCreateLabel={(inputValue) => `Add New : ${inputValue}`} // Customize the create label
            />
            {error.publisheGrouping && (
              <small className="error_message">{error.publisheGrouping}</small>
            )}
          </div>
          <div class="col-md-6">
            <label for="isbnNumber" class="form-label confirm_value ">
              ISBN Number
            </label>
            <input
              ref={isbn_ref}
              class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
              type="text"
              id="isbnNumber"
              name="isbnNumber"
              placeholder="Enter ISBN number"
              value={initialfields.isbnNumber}
              onChange={handleChange}
            />
            {error.isbnNumber && (
              <small className="error_message">{error.isbnNumber}</small>
            )}
          </div>

          <div class="col-md-6">
            <label for="tnoPage" class="form-label confirm_value ">
              Total Number of Pages
            </label>
            <input
              ref={tnopage_ref}
              class={`desc_input_text w-100 rounded-2 input-font-size-sm
                    `}
              type="number"
              id="tnoPage"
              name="tnoPage"
              min="1"
              placeholder="Enter total number of pages"
              // value={initialfields.tnoPage <= 0 ? "" : initialfields.tnoPage}
              value={
                initialfields.tnoPage === 0 || initialfields.tnoPage < 0
                  ? ""
                  : initialfields.tnoPage
              }
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || parseInt(value) > 0) {
                  handleChange(e);
                }
              }}
            />
            {error.tnoPage && (
              <small className="error_message">{error.tnoPage}</small>
            )}
          </div>

          <div className="col-lg-6 col-md-6">
            <div className="d-flex">
              <div className="row">
                <label for="uploadPrevImage" class="form-label confirm_value">
                  Sample Pages (in PDF)
                </label>
              </div>
              {initialfields.preview_path !== "" &&
                initialfields.preview_path !== null && (
                  <div className={"d-flex align-content-center p-0"}>
                    {initialfields.preview_path !== "" &&
                      initialfields.preview_path !== null && (
                        <>
                          <a
                            // href={`${ImageUrlPrefix}/${initialfields.original_preview_path}`}
                            to="javascript:void(0)"
                            onClick={() =>
                              handleDownload(
                                initialfields.original_preview_path,
                                initialfields.original_preview_path
                              )
                            }
                            // target="_blank"
                            download
                          >
                            <span className="material-icons align-middle download_icon">
                              file_download
                            </span>
                          </a>
                        </>
                      )}
                  </div>
                )}
            </div>

            {/* <div
                      className={
                        initialfields.preview_path !== "" &&
                        initialfields.preview_path !== null
                          ? "col-md- col-5 "
                          : "col-md-12"
                      }
                    > */}
            <input
              ref={answer_sheet_ref}
              // className={
              //   initialfields.preview_path !== "" &&
              //   initialfields.preview_path !== null
              //     ? "InputsSelectFile nn_upload_width"
              //     : "InputsSelectFile  vv_upload_width"
              // }
              className="InputsSelectFile m-0"
              type="file"
              id="formFile"
              name="preview_path"
              onChange={handleChange}
              required
            />

            {/* </div> */}
            {initialfields.preview_path !== "" &&
              initialfields.preview_path !== null &&
              id && (
                <div
                  className={"col-md-9 col-7 d-flex  align-content-center p-0"}
                >
                  <span className="nn_upload_fileevaluator">
                    {initialfields.preview_path !== "" &&
                    initialfields.preview_path !== null
                      ? initialfields.original_preview_path
                      : ""}
                  </span>
                  {/* {initialfields.preview_path !== "" &&
                            initialfields.preview_path !== null && (
                              <>
                                <span
                                  className={`${createInfo.verified_uploadeval} material-icons align-middle text-danger`}
                                >
                                  verified
                                </span>
                              </>
                            )} */}
                </div>
              )}

            {error.preview_path && (
              <span className="error_message">{error.preview_path}</span>
            )}
          </div>
          <div class="col-md-6">
            <label for="iframe" class="form-label confirm_value ">
              YouTube URL
            </label>
            <input
              ref={youtube_ref}
              className="desc_input_text w-100 rounded-2 input-font-size-sm"
              type="text"
              id="iframe"
              name="iframe"
              placeholder="Enter YouTube URL"
              value={initialfields.iframe || ""}
              onChange={handleIframeChange}
            />
            {error.iframe && (
              <small className="error_message">{error.iframe}</small>
            )}
          </div>
          {/* tag line */}
          <div class="col-md-6">
            <label for="bookName" class="form-label confirm_value ">
              Short Description
            </label>
            <input
              ref={tagLine_ref}
              class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
              type="text"
              id="tagLine"
              name="tagLine"
              maxLength={50}
              placeholder="Enter the short description (maximum 50 characters allowed)"
              value={initialfields.tagLine}
              onChange={handleChange}
            />
            {error.tagLine && (
              <small className="error_message">{error.tagLine}</small>
            )}
          </div>
          {initialfields.ebook == 1 ? (
            <div class="col-md-6">
              <label for="bookPathUrl" class="form-label confirm_value ">
                Book Path URL
              </label>
              <input
                ref={book_path_url_ref}
                class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                type="text"
                id="bookPathUrl"
                name="bookPathUrl"
                placeholder="Enter book path url"
                value={initialfields.bookPathUrl}
                onChange={handleChange}
              />
              {error.bookPathUrl && (
                <small className="error_message">{error.bookPathUrl}</small>
              )}
            </div>
          ) : (
            <div></div>
          )}

          <div class="col-12">
            <label for="description" class="form-label confirm_value ">
              Detailed Description
            </label>
            <textarea
              ref={description_ref}
              class="desc_input_text w-100 rounded-2 input-font-size-sm"
              placeholder="Enter detailed description here (maximum 1500 characters allowed)"
              id="description"
              onChange={handleChange}
              value={initialfields.description}
              name="description"
              maxLength={1500}
              rows="4"
            ></textarea>

            {error.description && (
              <span className="error_message">{error.description}</span>
            )}
          </div>
        </form>
      </fieldset>
      {initialfields.ebook == 0 ? (
        <fieldset className="mt-3">
          <legend className="w-auto">Stock Count</legend>
          <form className="row g-3">
            <div class="col-md-6">
              <label for="stockCount" class="form-label confirm_value ">
                {id ? "Current Stock Count" : "Stock Count"}
              </label>
              <input
                ref={stock_count_ref}
                class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                type="number"
                id="stockCount"
                name="stockCount"
                placeholder="Enter stock count"
                disabled={id}
                min="1"
                // value={initialfields.stockCount === 0 || initialfields.stockCount < 0 ? "" : initialfields.stockCount}
                value={
                  id
                    ? initialfields.stockCount // if disabled, always show whatever is in stockCount
                    : initialfields.stockCount ?? ""
                }
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || parseInt(value) > 0) {
                    handleChange(e);
                  }
                }}
              />
              {error.stockCount && (
                <small className="error_message">{error.stockCount}</small>
              )}
            </div>

            {id && (
              <div class="col-md-6">
                <label for="addCount" class="form-label confirm_value ">
                  New Stock Count
                </label>
                <input
                  ref={stock_count_ref}
                  class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                  type="number"
                  id="addCount"
                  name="addCount"
                  placeholder="Enter New stock count"
                  min="1"
                  value={
                    initialfields.addCount === 0 || initialfields.addCount < 0
                      ? ""
                      : initialfields.addCount
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || parseInt(value) > 0) {
                      handleChange(e);
                    }
                  }}
                />
                {/* {error.addCount && (
                  <small className="error_message">{error.addCount}</small>
                )} */}
              </div>
            )}
          </form>
        </fieldset>
      ) : (
        <div></div>
      )}

      <fieldset className="mt-3">
        <legend className="w-auto">Price</legend>

        <form className="row g-3">
          <div class="col-md-6">
            <label for="price" class="form-label confirm_value ">
              MRP
            </label>
            <input
              ref={price_ref}
              class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
              type="number"
              id="price"
              name="price"
              placeholder="Enter MRP"
              disabled={isFreeBook === 1}
              value={initialfields.price <= 0 ? "" : initialfields.price}
              onChange={handleChange}
            />
            {error.price && (
              <small className="error_message">{error.price}</small>
            )}
          </div>
          <div class="col-md-6">
            <label for="offerPer" class="form-label confirm_value ">
              Offer Percentage
            </label>
            <input
              ref={offerPer_ref}
              class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
              type="number"
              id="offerPer"
              name="offerPer"
              placeholder="Enter offer percentage"
              // value={initialfields.offerPer >= 0 ? "" : initialfields.offerPer}
              value={
                initialfields.offerPer >= 0 && initialfields.offerPer <= 99
                  ? initialfields.offerPer
                  : ""
              }
              disabled={isFreeBook === 1}
              onChange={handleChange}
            />
            {error.offerPer && (
              <small className="error_message">{error.offerPer}</small>
            )}
          </div>
        </form>
      </fieldset>
      <fieldset className="mt-3">
        <legend className="w-auto">Course Details</legend>
        <form className="row g-3">
          <div className="col-md-6">
            <label for="category" class="form-label confirm_value ">
              Category
            </label>
            <Select
              ref={category_ref}
              className={`shadow-none input-font-size `}
              name="categoryGrouping"
              isClearable={true}
              value={
                initialfields.CategoryTypeLabel &&
                initialfields.categoryGrouping
                  ? {
                      value: initialfields.categoryGrouping,
                      label: initialfields.CategoryTypeLabel,
                    }
                  : null
              }
              onChange={(option) =>
                handlechangeSelectDropdown(option, "categoryGrouping")
              }
              options={category}
              isSearchable={true} // Enables search functionality
              placeholder="Select category"
              maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
              filterOption={(option, searchText) =>
                option.label.toLowerCase().includes(searchText.toLowerCase())
              } // Filter options based on the search text
              styles={customStyles} // Apply custom styles her
            />
            {error.categoryGrouping && (
              <small className="error_message">{error.categoryGrouping}</small>
            )}
          </div>
          <div className="col-md-6">
            <label for="courseGrouping" class="form-label confirm_value ">
              Course
            </label>
            {/* <Select
              ref={course_ref}
              className={`shadow-none input-font-size `}
              name="courseGrouping"
              isClearable={true}
              value={
                initialfields.CourseTypeLabel && initialfields.courseGrouping
                  ? {
                    value: initialfields.courseGrouping,
                    label: initialfields.CourseTypeLabel,
                  }
                  : null
              }
              onChange={(option) =>
                handlechangeSelectDropdown(option, "courseGrouping")
              }
              options={groupName}
              isSearchable={true}
              placeholder="Select course"
              maxMenuHeight={200}
              filterOption={(option, searchText) =>
                option.label.toLowerCase().includes(searchText.toLowerCase())
              }
              styles={customStyles}
            /> */}
            <DropdownHeader
              txtAdCourse={course_ref}
              id="courseGrouping"
              name="courseGrouping"
              items={initialfields.CourseTypeLabel}
              record={courseListSortData}
              handleChangeCheckbox={handleChangeCheckbox}
              // handleChangeCheckbox={(option) =>
              //   handlechangeSelectDropdown(option, "courseGrouping")
              // }
            />
            {error.courseGrouping && (
              <small className="error_message">{error.courseGrouping}</small>
            )}
          </div>
          <div className="col-md-6">
            <label for="subject" class="form-label confirm_value ">
              Subject
            </label>

            <Select
              ref={subject_ref}
              className={`shadow-none input-font-size `}
              name="subjectGrouping"
              isClearable={true}
              value={
                initialfields.subjectTypeLabel && initialfields.subjectGrouping
                  ? {
                      value: initialfields.subjectGrouping,
                      label: initialfields.subjectTypeLabel,
                    }
                  : null
              }
              onChange={(option) =>
                handlechangeSelectDropdown(option, "subjectGrouping")
              }
              options={subjectGroupName}
              isSearchable={true} // Enables search functionality
              placeholder="Select subject"
              maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
              filterOption={(option, searchText) =>
                option?.label?.toLowerCase()?.includes(searchText.toLowerCase())
              } // Filter options based on the search text
              styles={customStyles} // Apply custom styles her
            />
            {error.subjectGrouping && (
              <small className="error_message">{error.subjectGrouping}</small>
            )}
          </div>
          <div className="col-md-6">
            <label for="mediumGrouping" class="form-label confirm_value ">
              Medium
            </label>
            <Select
              ref={medium_ref}
              className={`shadow-none input-font-size`}
              name="mediumGrouping"
              isClearable={true}
              value={
                initialfields.mediumGrouping !== undefined &&
                initialfields.mediumTypeLabel
                  ? {
                      value: initialfields.mediumGrouping,
                      label: initialfields.mediumTypeLabel,
                    }
                  : null
              }
              onChange={(option) =>
                handlechangeSelectDropdown(option, "mediumGrouping")
              }
              options={[
                { value: 0, label: "Tamil" },
                { value: 1, label: "English" },
                { value: 2, label: "Both" },
              ]}
              isSearchable={true}
              placeholder="Select medium"
              maxMenuHeight={200}
              filterOption={(option, searchText) =>
                option.label.toLowerCase().includes(searchText.toLowerCase())
              }
              styles={customStyles}
            />
            {error.mediumGrouping && (
              <small className="error_message">{error.mediumGrouping}</small>
            )}
          </div>
          <div className="col-md-6">
            <label for="seriesTag" class="form-label confirm_value ">
              Book Series
            </label>
            <Select
              ref={seriesTag_ref}
              className={`shadow-none input-font-size `}
              name="seriesGrouping"
              // isClearable={true}
              value={
                initialfields.seriesGrouping !== "" &&
                initialfields.seriesGrouping !== undefined
                  ? {
                      value: initialfields.seriesGrouping,
                      label: initialfields.seriesTypeLabel,
                    }
                  : ""
              }
              onChange={(option) =>
                handlechangeSelectDropdown(option, "seriesGrouping")
              }
              options={Tagsitems}
              // isSearchable={true}
              placeholder="Select series"
              maxMenuHeight={200}
              filterOption={(option, searchText) =>
                option.label?.toLowerCase().includes(searchText?.toLowerCase())
              }
              styles={customStyles}
            />
            {error.seriesGrouping && (
              <small className="error_message">{error.seriesGrouping}</small>
            )}
          </div>
        </form>
      </fieldset>

      {initialfields.ebook == 0 ? (
        <fieldset className="mt-3">
          <legend className="w-auto">Dimension and Weight</legend>

          <form className="row g-3">
            <div class="col-md-6">
              <label for="length" class="form-label confirm_value ">
                Length (in cm)
              </label>
              <input
                ref={length_ref}
                class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                type="number"
                id="length"
                maxLength={5}
                name="length"
                placeholder="Enter the length"
                // value={initialfields.length > 0 ? initialfields.length : ""}
                // onChange={handleChange}
                min="1"
                value={
                  initialfields.length === 0 || initialfields.length < 0
                    ? ""
                    : initialfields.length
                }
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || parseInt(value) > 0) {
                    handleChange(e);
                  }
                }}
              />
              {error.length && (
                <small className="error_message">{error.length}</small>
              )}
            </div>
            <div class="col-md-6">
              <label for="width" class="form-label confirm_value ">
                Width (in cm)
              </label>
              <input
                ref={width_ref}
                class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                type="number"
                id="width"
                maxLength={5}
                name="width"
                placeholder="Enter the width"
                // value={initialfields.width > 0 ? initialfields.width : ""}
                // onChange={handleChange}

                min="1"
                value={
                  initialfields.width === 0 || initialfields.width < 0
                    ? ""
                    : initialfields.width
                }
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || parseInt(value) > 0) {
                    handleChange(e);
                  }
                }}
              />
              {error.width && (
                <small className="error_message">{error.width}</small>
              )}
            </div>
            <div class="col-md-6">
              <label for="thickness" class="form-label confirm_value ">
                Thickness (in cm)
              </label>
              <input
                ref={thickness_ref}
                class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                type="number"
                id="thickness"
                maxLength={5}
                name="thickness"
                placeholder="Enter the thickness"
                // value={
                //   initialfields.thickness > 0 ? initialfields.thickness : ""
                // }
                // onChange={handleChange}
                min="1"
                value={
                  initialfields.thickness === 0 || initialfields.thickness < 0
                    ? ""
                    : initialfields.thickness
                }
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || parseInt(value) > 0) {
                    handleChange(e);
                  }
                }}
              />
              {error.thickness && (
                <small className="error_message">{error.thickness}</small>
              )}
            </div>
            <div class="col-md-6">
              <label for="weight" class="form-label confirm_value ">
                Weight (in kg)
              </label>
              <input
                ref={weight_ref}
                class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                type="number"
                id="weight"
                maxLength={5}
                name="weight"
                placeholder="Enter the weight"
                value={initialfields.weight}
                onChange={handleChange}
              />
              {error.weight && (
                <small className="error_message">{error.weight}</small>
              )}
            </div>
          </form>
        </fieldset>
      ) : (
        <div></div>
      )}

      <fieldset className="mt-3">
        <legend className="w-auto">Tags</legend>
        <form className="row g-3" onSubmit={(e) => e.preventDefault()}>
          <div className="col-md-6">
            <label for="tagsGrouping" class="form-label confirm_value ">
              Tags (Maximum 8 tags allowed)
            </label>

            <Creatable
              ref={tagsGrouping_ref}
              name="tagsGrouping"
              isMulti
              value={
                initialfields.tagsGrouping && initialfields.tagsLabel
                  ? initialfields.tagsGrouping.map((value, index) => ({
                      value: value,
                      label: initialfields.tagsLabel[index],
                    }))
                  : null
              }
              onChange={(selectedOptions) =>
                handlechangeSelectDropdown(selectedOptions, "tagsGrouping")
              }
              options={tagsList}
              isSearchable={true}
              placeholder="Select or enter new tags"
              maxMenuHeight={200}
              filterOption={(option, searchText) =>
                option?.label?.toLowerCase()?.includes(searchText.toLowerCase())
              }
              styles={customStyles}
              formatCreateLabel={(inputValue) => `Add New: ${inputValue}`}
            />

            {error.tagsGrouping && (
              <small className="error_message">{error.tagsGrouping}</small>
            )}
          </div>
        </form>
      </fieldset>
      <fieldset className="mt-3">
        <legend className="w-auto">Upload Images</legend>
        <form className="row g-3">
          <div className="col-lg-6 col-md-6">
            <div className="d-flex">
              <div className="row">
                <div className="d-flex">
                  <label for="uploadPrevImage" class="form-label confirm_value">
                    Upload Images (Max 4, 2MB each, JPG/PNG format)
                  </label>
                </div>
              </div>
            </div>
            <input
              ref={upload_image_ref}
              name="uploadPrevImage"
              type="file"
              className="InputsSelectFile"
              multiple
              accept="image/*"
              onChange={handleChange}
              disabled={
                initialfields.upload_image_path?.filter(
                  (image) => image?.is_valid !== 0
                ).length >= 4
              }
            />
            <div
              style={{
                display: "flex",
                gap: "10px",
                // flexWrap: "wrap",
                position: "relative",
              }}
            >
              {initialfields.upload_image_path?.length > 0 &&
                initialfields.upload_image_path.map(
                  (image, index) =>
                    image?.is_valid !== 0 && (
                      <div
                        key={index}
                        style={{
                          position: "relative",
                          display: "inline-block",
                          marginTop: "10px",
                        }}
                      >
                        <img
                          key={index}
                          className={createInfo.multiImage}
                          src={`${baseURL}/${
                            typeof image === "string" ? image : image.path
                          }`}
                          alt={`Preview ${index + 1}`}
                          style={{
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            margin: "5px",
                          }}
                        />
                        <button
                          onClick={(e) => handleDelete(e, index)}
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "0",
                            left: "90%",
                            background: "red",
                            color: "white",
                            border: "none",
                            borderRadius: "50%",
                            width: "20px",
                            height: "20px",
                            cursor: "pointer",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          &times;
                        </button>
                      </div>
                    )
                )}
            </div>

            {error.upload_image_path && (
              <span className="error_message">{error.upload_image_path}</span>
            )}
          </div>
        </form>
      </fieldset>
      <div className="offset-md-12 col-12 ListBtn pt-2">
        <ul class="List-Button">
          <li class="ListBtnItems">
            <Link
              to="javascript:void(0)"
              onClick={navigateToPreviousScreen}
              className="secondaryButton "
              variant="secondary"
            >
              {id ? "Back to View Book" : "Back to Books"}
            </Link>
          </li>
          <li class="ListBtnItems">
            <Link
              to="javascript:void(0)"
              onClick={handleSubmit}
              className="primaryButton text-center "
              variant="primary"
            >
              Save Book
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}
